import { coachById } from '../../fixtures/coaches';
import { renderCoachName } from '../../lib/coachName';
import { MarketingPhoneStatusBar } from './MarketingPhoneFrame';
import styles from './CoachConversationPreview.module.css';

/**
 * Static chat preview with AIro (canonical training-coach name) for
 * the Plan Showcase section. Marketing-only — no real chat behavior,
 * no real interactive elements (composer is visual only, not a real
 * input).
 *
 * Uses the canonical training-coach (AIro) from the COACHES fixture.
 */
const AIRO = coachById('training-coach');

export function CoachConversationPreview() {
  return (
    <>
      <MarketingPhoneStatusBar />
      <div className={styles.surface}>
        <div className={styles.coachHeader}>
          <span className={styles.avatar}>{AIRO.initial}</span>
          <div className={styles.coachInfo}>
            <span className={styles.coachName}>
              {/* This phone surface has a LIGHT chat area but the
                  header background is paper (white), where AIRO's
                  teal still reads cleanly — keep coach color here. */}
              {renderCoachName(AIRO.name, AIRO.token)}
              <span className={styles.onlineDot} aria-hidden />
            </span>
            <span className={styles.coachRole}>{AIRO.role} · online</span>
          </div>
        </div>

        <span className={styles.contextPill}>
          Today · 3 mi easy · Build phase
        </span>

        <div className={styles.messages}>
          <div className={`${styles.message} ${styles.coach}`}>
            Quick check before today: how did Saturday&rsquo;s long run feel?
          </div>
          <div className={`${styles.message} ${styles.user}`}>
            Last 2 miles felt heavy. Legs are tired.
          </div>
          <div className={`${styles.message} ${styles.coach}`}>
            That tracks. Your weekly load is up 12% from last week. Today
            stays easy. We&rsquo;ll watch tomorrow&rsquo;s tempo.
          </div>
          <div className={`${styles.message} ${styles.user}`}>
            Should I cut tomorrow&rsquo;s tempo if I&rsquo;m still tired?
          </div>
        </div>

        {/* Visual-only composer — not a real input element */}
        <div className={styles.composer}>
          <span>Ask {AIRO.name} anything…</span>
          <span className={styles.composerSend} aria-hidden>
            ↑
          </span>
        </div>
      </div>
    </>
  );
}
